import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  size?: 'default' | 'large';
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  size = 'default',
  className = ''
}: CTAButtonProps) {
  const sizeClasses = size === 'large' ? 'px-8 py-4 md:px-10 md:py-5 text-lg md:text-2xl' : 'px-6 py-3 md:px-8 md:py-4 text-base md:text-xl';
  return <button onClick={onClick} className={`bg-gold-accent hover:bg-gold-light text-navy-primary font-bold rounded-xl shadow-lg hover:shadow-xl shadow-[inset_0_1px_0_rgba(255,255,255,0.4)] transition-all duration-200 hover:-translate-y-0.5 hover:scale-[1.02] active:scale-[0.98] ${sizeClasses} ${className}`} data-id="element-300">
      {children}
    </button>;
}